module.exports = __webpack_public_path__ + "static/media/harrys_logo.7e6321e1.svg";